import React, { useState, useEffect, useRef } from "react";
import {
  Autocomplete,
  CardContent,
  DatePicker,
  FullscreenDialog,
  Grid,
  Paper,
  Tabs,
  Tab,
  TabPanel,
  TextField,
  FormControl,
  CircularProgress,
  Button,
  Tooltip,
  IconButton,
  Checkbox,
  FormControlLabel,
} from "../../../components";
import { useTheme } from "@mui/material/styles";
import { AddLayout } from "../../../layouts";
import {
  notification,
  OrcamentosService,
  OrcamentosItensService,
  PessoaService,
  MeioPagamentoService,
  ProdutosService,
  OperacaoFiscalService,
  history,
  SessionService,
  ColaboradorService,
  OrigemMercadoriaService,
  TabelaVendaService,
  EnderecosEstoqueService,
} from "../../../services";
import { InputErros, PermisoesHelper, value } from "../../../helpers";
import {
  responseErros,
  formatDate,
  timeoutBuscaAutocomplete,
  userLogs,
  voltar,
  formatPrecisaoFloat,
  montarFiltroPessoa,
} from "../../../utils";
import { enderecoValidator, orcamentosValidator } from "./middlewares";
import {
  ButtonMenu,
  OrcamentosItens,
  OrcamentosCampos,
  OrcamentosDadosClientes,
  ComissaoVendedorDialog,
  ResumoTotal,
} from "./components";
import {
  tabProps,
  calcularValorTotal,
  encontrarEnderecoPadrao,
  mapearEnderecos,
  mapearEndereco,
  limparCampoTotalizador,
  calcularPrecoProduto,
  formatTotalItemAcrescimo,
  validarTabelaVendaMeioPagamento,
  validarTabelaTodosProdutosMeioPagamento,
  validarTabelaVendaCliente,
} from "./addOrcamentos";
import AddPessoas from "../../pessoas/addPessoa/addPessoa.view";
import { useImportContext } from "../../../contexts/import.context";
import { Orcamento } from "./entities";
import { format } from "date-fns";
import HistorioClienteDialog from "./components/dialogComponents/historico-cliente-dialog.component";
import shortid from "shortid";

const sessionService = new SessionService();
const colaboradorService = new ColaboradorService();
const orcamentosService = new OrcamentosService();
const orcamentosItensService = new OrcamentosItensService();
const pessoaService = new PessoaService();
const meioPagamentoService = new MeioPagamentoService();
const produtosService = new ProdutosService();
const tabelaVendaService = new TabelaVendaService();
const operacaoFiscalService = new OperacaoFiscalService();
const origemMercadoriaService = new OrigemMercadoriaService();
const enderecosEstoqueService = new EnderecosEstoqueService();

let orcamentoEntity = new Orcamento({
  dataEmissao: formatDate.toSend(new Date()),
  entrada: 0,
  desconto: 0,
  acrescimo: 0,
  despesas: 0,
});

const AddOrcamentosView = ({ match }) => {
  const theme = useTheme();
  const { id } = match.params;
  const { initialCollapses } = useImportContext();
  const inputCliente = useRef();
  const [loading, setLoading] = useState(true);
  const [userLog, setUserLog] = useState({});
  const [isCadastroPessoaDialogOpen, setIsCadastroPessoaDialogOpen] =
    useState(false);
  const [openHistoricoClienteDialog, setOpenHistoricoClienteDialog] =
    useState(false);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [abaValue, setAbaValue] = useState(0);
  const [acrescimoPagamento, setAcrescimoPagamento] = useState(null);
  const [orcamento, setOrcamento] = useState(orcamentoEntity);
  const [itemValorComissaoVendedor, setItemValorComissaoVendedor] =
    useState(null);
  const [itemPercentualComissaoVendedor, setItemPercentualComissaoVendedor] =
    useState(null);
  const [itemTotalComissaoVendedor, setItemTotalComissaoVendedor] =
    useState(null);
  const [clienteList, setClienteList] = useState([]);
  const [vendedorList, setVendedorList] = useState([]);
  const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [meiosPagamentoCliente, setMeiosPagamentoCliente] = useState(null);
  const [operacaoFiscalList, setOperacaoFiscalList] = useState([]);
  const [produtoList, setProdutoList] = useState([]);
  const [produto, setProduto] = useState(null);
  const [produtosSimilares, setProdutosSimilares] = useState([]);
  const [cidadeId, setCidadeId] = useState(null);
  const [endereco, setEndereco] = useState({
    padrao: false,
  });
  const [obrigatoriedadeMeioPagamento, setObrigatoriedadeMeioPagamento] =
    useState(false);
  const [enderecoCliente, setEnderecoCliente] = useState(null);
  const [enderecoClienteDataGrid, setEnderecoClienteDataGrid] = useState([]);
  const [enderecoAleterado, setEnderecoAleterado] = useState(null);
  const [pagamentoSelecionado, setPagamentoSelecionado] = useState(null);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [tabelas, setTabelas] = useState({
    cliente: null,
    grupoPessoa: null,
  });
  const [tabelasTodosProdutos, setTabelasTodosProdutos] = useState([]);
  const [listaOrcamentosProdutos, setListaOrcamentosProdutos] = useState([]);
  const [origensMercadoriasList, setOrigensMercadoriasList] = useState([]);
  const [enderecosEstoqueList, setEnderecosEstoqueList] = useState([]);
  const [listaUnidadesComerciais, setListaUnidadesComerciais] = useState([]);
  const [openDialogEnvioWhatsapp, setOpenDialogEnvioWhatsapp] = useState(false);
  const [tiposTotalizadoresColumnView, setTiposTotalizadoresColumnView] =
    useState(false);
  const [orcamentos, setOrcamentos] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("orcamentos-visualizar");
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const dadosEmpresaUsuario = sessionService.getEmpresaAndUsuario();
  const containerRef = useRef(null);
  const tiposPessoa = [
    {
      tipoId: 1,
      setLista: (dados) => setClienteList(dados),
    },
    {
      tipoId: 4,
      setLista: (dados) => setVendedorList(dados),
    },
  ];

  const buscarConfiguracao = async () => {
    if (dadosEmpresaUsuario.empresa.configuracoes) {
      const data = dadosEmpresaUsuario.empresa.configuracoes;
      setObrigatoriedadeMeioPagamento(data?.obrigatoriedadeMeioPagamento);
      if (data?.obrigatoriedadeMeioPagamento) {
        setAbaValue(2);
      }
      orcamentoEntity.setConfiguracoes(data);
      setOrcamento({ ...orcamentoEntity });
      if (data.operacaoFiscalVendasPadraoId) {
        await buscarOperacaoFiscal(data.operacaoFiscalVendasPadraoId);
        return true;
      }
    }
  };

  async function buscaDadosIniciais() {
    await buscarPessoaVendedor();
    await buscaOrcamentos();
    await Promise.all([buscarMeiosPagamento(), buscarOrigensMercadoria()]);
    const operacaoPadrao = await buscarConfiguracao();
    if (!operacaoPadrao) buscarOperacaoFiscal();
    await buscarTabelasVendaTodosProdutos();
    await buscarEnderecosEstoque();
  }

  useEffect(() => {
    buscaDadosIniciais().then(() => {
      setLoading(false);
    });
  }, []);

  const validarProdutosTabelaVenda = (tabelasVenda = null) => {
    const tabelasVendaProduto = tabelasVenda ?? tabelas;
    const tabelaTodosProdutos = validarTabelaTodosProdutosMeioPagamento(
      tabelasTodosProdutos,
      pagamentoSelecionado?.id,
    );

    if (listaOrcamentosProdutos.length > 0) {
      const produtosAtualizados = listaOrcamentosProdutos.map(
        (pedidoProduto) => {
          let resultItem = {
            ...pedidoProduto,
            descontoPorcentagem: 0,
            desconto: 0,
            despesas: 0,
          };
          if (
            validarTabelaVendaCliente(
              tabelasVendaProduto?.cliente,
              resultItem.produtoId,
            )
          ) {
            resultItem = calcularPrecoProduto(
              resultItem,
              tabelasVendaProduto?.cliente,
            );
          } else if (tabelasVendaProduto?.grupoPessoa) {
            resultItem = calcularPrecoProduto(
              resultItem,
              tabelasVendaProduto?.grupoPessoa,
            );
          } else if (
            validarTabelaVendaMeioPagamento(
              pedidoProduto?.tabelasVenda,
              pagamentoSelecionado?.id,
            )
          ) {
            resultItem = calcularPrecoProduto(
              resultItem,
              resultItem?.tabelasVenda[0] || {},
              "meioPagamento",
            );
          } else if (tabelaTodosProdutos) {
            resultItem = calcularPrecoProduto(resultItem, tabelaTodosProdutos);
            const { totalItem } = formatTotalItemAcrescimo(
              resultItem,
              acrescimoPagamento,
            );
            resultItem.totalItem = totalItem;
          } else {
            const { valorUnitario, totalItem } = formatTotalItemAcrescimo(
              resultItem,
              acrescimoPagamento,
            );
            resultItem.valorUnitario = valorUnitario;
            resultItem.totalItem = totalItem;
            resultItem.desconto = pedidoProduto.desconto;
            resultItem.descontoPorcentagem = pedidoProduto.descontoPorcentagem;
            resultItem.despesas = pedidoProduto.despesas;
          }
          return resultItem;
        },
      );
      orcamentoEntity.setChangeItens(produtosAtualizados);
      setOrcamento(orcamentoEntity);
      setListaOrcamentosProdutos(produtosAtualizados);
    }
  };

  useEffect(() => {
    validarProdutosTabelaVenda();
  }, [pagamentoSelecionado]);

  const buscarPessoaVendedor = async (filtros) => {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      vendedor: true,
    };
    const result = await colaboradorService.getAll(filtro);
    if (!result.isAxiosError) {
      setVendedorList(
        result.data.map((vendedor) => ({
          ...vendedor.pessoa,
          ...vendedor,
          id: vendedor.pessoa.id,
        })),
      );
      const colaboradorVendedorUsuario = result.data.find(
        (colaborador) =>
          colaborador.usuarioId === dadosEmpresaUsuario.usuario.id,
      );
      if (colaboradorVendedorUsuario) {
        orcamentoEntity.setHandleChangeInput(
          "pessoaVendedorId",
          colaboradorVendedorUsuario.pessoa.id,
        );
        setOrcamento(orcamentoEntity);
      }
    } else {
      responseErros(result);
    }
  };

  const buscaOrcamentos = async () => {
    if (!id) {
      orcamentoEntity = new Orcamento({
        dataEmissao: formatDate.toSend(new Date()),
        entrada: 0,
        desconto: 0,
        acrescimo: 0,
        despesas: 0,
      });
      return;
    }
    const result = await orcamentosService.getById(id);
    if (!result.isAxiosError) {
      if (!result.data) {
        initialCollapses();
        voltar();
        return;
      }
      orcamentoEntity = new Orcamento(result.data, id);
      await inserirDadosOrcamento();
    } else {
      responseErros(result);
      initialCollapses();
      voltar();
    }
  };

  async function inserirDadosOrcamento() {
    setOrcamento(orcamentoEntity);
    buscarProdutosAvancado(orcamentoEntity?.itens);
    setEnderecoAleterado(orcamentoEntity?.orcamentoEnderecoCliente);
    buscarDadosClientes(orcamentoEntity?.pessoaClienteId);
  }

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(orcamento);
    setUserLog(logs);
  }

  const buscarPessoas = async (filtros, tiposPessoaId) => {
    const filtro = {
      ...filtros,
      tiposPessoaId,
      limite: 20,
      ativado: true,
    };
    const tipoPessoaTemp = tiposPessoa.find(
      ({ tipoId }) => tipoId === tiposPessoaId,
    );
    pessoaService.getAll(filtro).then((res) => {
      setLoadingAutoComplete(false);
      if (!res.isAxiosError) {
        tipoPessoaTemp?.setLista(res.data.rows);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarOperacaoFiscal = async (id) => {
    const filtros = {
      ativado: true,
      tipoOperacao: "SAIDA",
      restritiva: true,
      finalidade: ["NAO_SE_APLICA", "NFE_NORMAL"],
    };
    operacaoFiscalService.getAllFiltroAvancado(filtros).then((result) => {
      if (!result.isAxiosError) {
        setOperacaoFiscalList(result.data.rows);
        if (!id && result.data.rows?.length) {
          const operacaoPadrao = result.data.rows.find(
            (operacao) => operacao.id === id,
          );
          if (operacaoPadrao) {
            orcamentoEntity.setOperacaoFiscal(operacaoPadrao);
            setOrcamento((prevState) => ({ ...prevState, ...orcamentoEntity }));
          }
        }
      } else {
        responseErros(result);
      }
    });
  };

  const buscarEnderecosEstoque = () => {
    const filter = {
      nonPaginated: true,
    };
    enderecosEstoqueService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setEnderecosEstoqueList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarDadosClientes = async (clienteId) => {
    if (!clienteId) return;
    pessoaService.getById(clienteId).then((result) => {
      if (!result.isAxiosError) {
        setClienteSelecionado(result.data);
        buscarDocumentosCliente(clienteId);
        if (result.data.enderecos?.length)
          adicionarEnderecosCliente(result.data.enderecos);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDocumentosCliente = async (pessoaClienteId) => {
    setLoadingHistorico(true);
    orcamentosService
      .getAll({ pessoaClienteId })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data.rows.length) {
            setOrcamentos(result.data.rows);
            setTotalItems(result.data.count);
          } else {
            setOrcamentos([]);
            setTotalItems(0);
          }
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoadingHistorico(false));
  };

  async function adicionarEnderecosCliente(enderecos) {
    const enderecoPadrao = encontrarEnderecoPadrao(enderecos);
    if (enderecoPadrao) {
      const enderecoCliente = await mapearEndereco(enderecoPadrao);
      setEnderecoCliente(enderecoCliente);
      orcamentoEntity.setEnderecoCliente(null, enderecoCliente);
    }
    const enderecosMapeados = await mapearEnderecos(enderecos);
    setEnderecoClienteDataGrid(enderecosMapeados);
  }

  const removerDadosCliente = () => {
    setInputErro([]);
    setEnderecoClienteDataGrid([]);
    setEnderecoCliente(null);
    setEnderecoAleterado(null);
    orcamentoEntity.setEnderecoCliente();
  };

  const onChangeAutocompleteCliente = (newValue) => {
    removerDadosCliente();
    orcamentoEntity.setHandleChangeAutoComplete("pessoaClienteId", newValue);
    setOrcamento(orcamentoEntity);
    setClienteSelecionado(newValue);
    buscarDadosClientes(newValue?.id);
    if (newValue?.clientes?.length) {
      buscarTodasTabelasVenda(
        newValue?.id,
        newValue?.clientes?.[0]?.grupoPessoaId,
      );
      filterMeiosPagamentoCliente(newValue.clientes[0]);
      const sugestaoVendedorId = newValue.clientes[0].sugestaoVendedorId;
      const sugestaoVendedor = vendedorList.filter(
        ({ pessoaId }) => pessoaId === sugestaoVendedorId,
      );
      if (sugestaoVendedorId && sugestaoVendedor.length > 0) {
        handleChangeAutocomplete("pessoaVendedorId", sugestaoVendedor[0]);
      }
    } else {
      const tabelaVazia = {
        cliente: null,
        grupoPessoa: null,
      };
      setTabelas(tabelaVazia);
      validarProdutosTabelaVenda(tabelaVazia);
      setMeiosPagamentoCliente(null);
    }
  };

  const filterMeiosPagamentoCliente = (cliente) => {
    if (cliente.meiosPagamento?.length) {
      const meioPagamentoIds = cliente.meiosPagamento.map(
        ({ meioPagamentoId }) => meioPagamentoId,
      );
      const filterMeioPagamento = meioPagamentoList.filter((item) =>
        meioPagamentoIds.includes(item.id),
      );
      setMeiosPagamentoCliente(filterMeioPagamento);
      const meioPagamentoValido = meioPagamentoIds.find(
        (id) => id === orcamento?.meioPagamentoId,
      );
      if (orcamento?.meioPagamentoId && !meioPagamentoValido) {
        setOrcamento((prevState) => ({
          ...prevState,
          meioPagamentoId: null,
          condicaoPagamentoId: null,
        }));
        setCondicaoPagamentoList([]);
      }
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  const buscarOrigensMercadoria = () => {
    origemMercadoriaService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setOrigensMercadoriasList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarTabelasVendaTodosProdutos = async () => {
    const filtros = {
      ativado: true,
      nonPaginated: true,
      restritiva: true,
      tabelaRegente: true,
      tipoTabela: "TODOS_PRODUTOS",
    };
    const response = await tabelaVendaService.getAll(filtros);
    if (!response.isAxiosError) {
      setTabelasTodosProdutos(response.data);
    } else {
      responseErros(response);
    }
  };

  const buscarTodasTabelasVenda = async (pessoaId, intGrupoPessoaId) => {
    setLoading(true);
    try {
      const filtros = {
        ativado: true,
        nonPaginated: true,
        restritiva: true,
        tabelaRegente: true,
        tipoTabela: "POR_PRODUTO",
      };
      const response = await tabelaVendaService.getAll(filtros);
      if (response.isAxiosError) {
        responseErros(response);
        return;
      }
      const tabelasProcessadas = response.data.reduce(
        (acc, tabela) => {
          const pessoa = tabela?.pessoaIds.find(
            (tabelaPessoa) => tabelaPessoa.intPessoaId == pessoaId,
          );
          if (pessoa) {
            acc.cliente = tabela;
          } else if (
            intGrupoPessoaId &&
            tabela.intGrupoPessoaId === intGrupoPessoaId
          ) {
            acc.grupoPessoa = tabela;
          }
          return acc;
        },
        { cliente: null, grupoPessoa: null },
      );

      validarProdutosTabelaVenda(tabelasProcessadas);
      setTabelas(tabelasProcessadas);
    } catch (error) {
      console.error("Erro ao buscar tabelas:", error);
    } finally {
      setLoading(false);
    }
  };

  const buscarMeiosPagamento = (filtros) => {
    const filtro = {
      ...filtros,
      ativado: true,
      nonPaginated: true,
    };
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamentoList(result.data);
        if (id) {
          const meioPagamento = result.data.find(
            ({ id }) => orcamentoEntity.meioPagamentoId === id,
          );
          setPagamentoSelecionado(meioPagamento);
          setCondicaoPagamentoList(meioPagamento.condicoesPagamento ?? []);
        }
      } else {
        responseErros(result);
      }
    });
  };

  const buscarProdutosAvancado = (itens) => {
    const produtosIds = itens.map(({ produtoId }) => produtoId);
    const filtro = {
      id: produtosIds,
      ativado: true,
      nonPaginated: true,
      tabelasVenda: true,
    };
    produtosService.getAllFiltroAvancado(filtro).then((result) => {
      if (!result.isAxiosError) {
        setProdutoList(result.data);
        if (itens && itens.length) {
          preencherItens(itens, result.data);
        }
      } else {
        responseErros(result);
      }
    });
  };

  const preencherItens = (itensBusca, produtos) => {
    const itens = itensBusca.map((item) => {
      const produtoBusca = produtos.find(
        (produto) => produto.id == item.produtoId,
      );
      return {
        ...item,
        descricao: produtoBusca?.descricao,
        totalItem: calcularValorTotal(item),
        precoVenda: produtoBusca?.informacao?.precoVenda,
        tabelasVenda: produtoBusca?.tabelasVenda,
      };
    });
    orcamentoEntity.setChangeItens(itens);
    setOrcamento(orcamentoEntity);
    setListaOrcamentosProdutos(itens);
  };

  const buscarProdutosSimilares = async (produtoId) => {
    if (produtoId) {
      produtosService.getById(produtoId).then((result) => {
        if (!result.isAxiosError) {
          setProdutosSimilares(result.data.similares);
        } else {
          responseErros(result);
        }
      });
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    orcamentoEntity.setHandleChangeAutoComplete(name, value);
    if (name === "meioPagamentoId") {
      setPagamentoSelecionado(value);
      setCondicaoPagamentoList(value?.condicoesPagamento ?? []);
      orcamentoEntity.setHandleChangeInput("condicaoPagamentoId", null);
    }
    if (name === "condicaoPagamentoId") {
      setAcrescimoPagamento(value?.pagamentoInfo?.acrescimo);
      recalcularProdutosAcrescimoPagamento(value?.pagamentoInfo?.acrescimo);
      setAbaValue((prevState) =>
        value && obrigatoriedadeMeioPagamento ? 0 : prevState,
      );
    }
    setOrcamento((prevState) => ({ ...prevState, ...orcamentoEntity }));
  };

  function recalcularProdutosAcrescimoPagamento(acrescimo) {
    const calculoValorUnitario = (acrescimo, produto) =>
      acrescimo > 0
        ? formatPrecisaoFloat(
            produto?.valorUnitario + produto?.valorUnitario * (acrescimo / 100),
          )
        : produto?.valorUnitario;
    const calculoDesconto = (valor, produto) =>
      produto?.descontoPorcentagem
        ? (valor *
            produto.quantidade *
            parseFloat(produto?.descontoPorcentagem)) /
          100
        : produto?.desconto;
    const valorUnitario = calculoValorUnitario(acrescimo, produto);
    if (produto) {
      setProduto((prevState) => ({
        ...prevState,
        valorUnitario,
        totalItem: valorUnitario * prevState.quantidade,
        desconto: calculoDesconto(valorUnitario, prevState),
      }));
    }
    if (listaOrcamentosProdutos?.length) {
      const listaItens = listaOrcamentosProdutos.map((item) => {
        const valorUnitario = calculoValorUnitario(acrescimo, item);
        return {
          ...item,
          valorUnitario,
          desconto: calculoDesconto(valorUnitario, item),
          totalItem: valorUnitario * item.quantidade,
        };
      });
      setListaOrcamentosProdutos(listaItens);
      orcamentoEntity.setChangeItens(listaItens);
      setOrcamento(orcamentoEntity);
    }
  }

  const handleChangeInput = (event) => {
    orcamentoEntity.setHandleChangeInput(event.target.name, event.target.value);
    setOrcamento(orcamentoEntity);
  };

  const onSearchChangePessoas = (event, tiposPessoaId) => {
    if (
      event.key === "Enter" &&
      inputCliente.current === document.activeElement
    ) {
      const filtros = montarFiltroPessoa(event.target?.value, tiposPessoaId);
      setLoadingAutoComplete(true);
      buscarPessoas(filtros, tiposPessoaId);
    }
  };

  const handleCloseCadastroCliente = () => {
    buscarPessoas();
    setOrcamento(orcamentoEntity);
    setIsCadastroPessoaDialogOpen(false);
  };

  const buscarProdutosCadastrados = () => {
    const filter = {
      nonPaginated: true,
      orcamentoId: id,
    };
    orcamentosItensService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        preencherItens(res.data, produtoList);
      } else {
        responseErros(res);
      }
    });
  };

  const removerProdutoCadastrado = async (idProduto) => {
    setLoading(true);
    const res = await orcamentosItensService.deletarEmLote(idProduto);
    if (!res.isAxiosError) {
      buscarProdutosCadastrados();
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const salvarEndereco = async () => {
    const body = {
      ...endereco,
      cidadeId: cidadeId,
      pessoaId: orcamento?.pessoaClienteId,
    };
    enderecoValidator
      .validate(body, { abortEarly: false })
      .then(async () => {
        setLoading(true);
        const res = await pessoaService.cadastrarEndereco(
          orcamento?.pessoaClienteId,
          body,
        );
        if (!res.isAxiosError) {
          notification.cadastroSucesso();
          setEnderecoClienteDataGrid([
            ...enderecoClienteDataGrid,
            { ...body, id: shortid.generate() },
          ]);
        } else {
          responseErros(res);
        }
        setLoading(false);
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const verificaVendaPrazo = () => {
    const pagamentoOrcamento = id
      ? meioPagamentoList.find(({ id }) => id === orcamento?.meioPagamentoId)
      : pagamentoSelecionado;
    if (!pagamentoOrcamento?.baixaAutomatica && !orcamento.pessoaClienteId) {
      notification.alertaGenericos(
        "É necessário informar cliente para vendas a prazo",
      );
      setLoading(false);
      return true;
    }
    return false;
  };

  const handleSubmit = async (indiceSelecionado) => {
    setLoading(true);
    orcamentoEntity.setEnderecoCliente(enderecoAleterado, null);
    orcamentosValidator
      .validate(orcamentoEntity, { abortEarly: false })
      .then(async () => {
        const verificarVendaPrazo = verificaVendaPrazo();
        if (verificarVendaPrazo) return;
        if (id) {
          const response = await orcamentosService.atualizar(
            id,
            orcamentoEntity,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            initialCollapses();
            voltar();
          } else {
            buscaOrcamentos();
            responseErros(response);
          }
        } else {
          const response = await orcamentosService.cadastrar(orcamentoEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            setOrcamento({ ...orcamento, ...response.data });
            notification.cadastroSucesso();
            if (indiceSelecionado === 0) {
              const permissaoDeny = permissoesHelper.temPermisao(
                "orcamentos-enviar-documento-apos-criacao",
              );
              const props = {
                title: "Documento cadastrado com sucesso",
                text: `#${response.data.numeroDocumento}`,
                icon: "success",
                confirmButtonText: "IMPRIMIR",
                cancelButtonText:
                  permissaoDeny ? "EMAIL" : "FECHAR",
                showCancelButton: true,
                showCloseButton: permissaoDeny,
                closeButtonHtml:
                  "<i class='ph-bold ph-x' style='font-size: 21px' aria-hidden='true'></i>",
                dangerMode: true,
              };
              if (
                permissaoDeny &&
                dadosEmpresaUsuario.empresa?.whatsappSimples
              ) {
                props.width = "min(38rem, calc(100vw - 2rem))";
                props.denyButtonText = "WHATSAPP";
                props.showDenyButton = true;
              }
              const confirmacaoAlerta = await notification.confirmacaoGenericos(
                props,
              );
              if (confirmacaoAlerta.isConfirmed) {
                document.getElementById("botaoMenuAction")?.click();
              } else if (confirmacaoAlerta?.isDenied) {
                setOpenDialogEnvioWhatsapp(true);
              } else if (
                confirmacaoAlerta?.dismiss === "cancel" &&
                permissaoDeny
              ) {
                document.getElementById("botaoEmailAction")?.click();
              } else {
                initialCollapses();
                voltar();
              }
            } else {
              handleCancelar();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    orcamentoEntity = new Orcamento({
      dataEmissao: formatDate.toSend(new Date()),
      entrada: 0,
      desconto: 0,
      acrescimo: 0,
      despesas: 0,
    });
    setOrcamento(orcamentoEntity);
    setListaOrcamentosProdutos([]);
  };

  const onClickCancelarOrcamento = async () => {
    const retornoAlerta = await notification.confirmacao(
      "Cancelar!",
      "Tem certeza que deseja cancelar esse orçamento?",
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const response = await orcamentosService.cancelar(id);
      setLoading(false);
      if (!response.isAxiosError) {
        notification.alteracaoSucesso();
        history.push("/faturamento/orcamentos");
      } else {
        responseErros(response);
      }
    }
  };

  const handleChangeSwitch = (e) => {
    const name = e.target.name;
    if (
      (name === "descontoItem" || name === "despesasItem") &&
      orcamentoEntity.itens?.length
    ) {
      const nomeCampo = name.replace("Item", "");
      const listaItensTotalizador = limparCampoTotalizador(
        nomeCampo,
        orcamentoEntity.itens,
      );
      orcamentoEntity.setChangeItens(listaItensTotalizador);
      setProdutoList([...orcamentoEntity.itens]);
      setProduto((prevState) => ({
        ...prevState,
        [nomeCampo]: 0,
      }));
    }
    orcamentoEntity.setHandleChangeSwitch(name, e.target.checked);
    setOrcamento({ ...orcamentoEntity });
  };

  return (
    <AddLayout
      id={id}
      showUpdate={
        orcamento.status === "ABERTO" ||
        permissoesHelper.temPermisao("orcamentos-editar")
      }
      title={id ? "Editar orçamentos" : "Cadastrar orçamentos"}
      onClickSalvar={handleSubmit}
      loading={loading}
      codigo={
        id && orcamento?.numeroDocumento
          ? `Nº Documento ${orcamento?.numeroDocumento}`
          : ""
      }
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      ButtonMenu={
        <ButtonMenu
          id={id}
          data={{
            ...orcamento,
            empresa: dadosEmpresaUsuario.empresa,
            itens: listaOrcamentosProdutos,
            dataEmissaoFormat: format(
              new Date(Date.parse(orcamento.dataEmissao)),
              "dd/MM/yyyy HH:MM",
            ),
            vendedor: value.autoComplete(
              vendedorList,
              orcamento?.pessoaVendedorId,
            )?.nomeRazaoSocial,
            cliente: clienteSelecionado,
            enderecoCliente: enderecoAleterado || enderecoCliente,
            estadoCliente: enderecoCliente?.estado,
            meioPagamentoList,
          }}
          configuracoes={dadosEmpresaUsuario?.empresa?.configuracoes}
          openDialogEnvioWhatsapp={openDialogEnvioWhatsapp}
          setOpenDialogEnvioWhatsapp={setOpenDialogEnvioWhatsapp}
          onClickCancelarOrcamento={onClickCancelarOrcamento}
        />
      }
      actionsTotalizadores={
        <ResumoTotal
          abaValue={abaValue}
          orcamento={orcamento}
          setOrcamento={setOrcamento}
          listaOrcamentosProdutos={listaOrcamentosProdutos}
          setListaOrcamentosProdutos={setListaOrcamentosProdutos}
          orcamentoEntity={orcamentoEntity}
        />
      }
      // formState={{
      //   inicial: id
      //     ? orcamentoEntity
      //     : {
      //         dataEmissao: formatDate.toSend(new Date()),
      //         entrada: 0,
      //         desconto: 0,
      //         acrescimo: 0,
      //         despesas: 0,
      //       },
      //   final: orcamento,
      // }}
    >
      <Grid container spacing={2}>
        <Grid item xs={1}>
          <FormControl variant="outlined" fullWidth>
            <TextField
              id="serieDocumento"
              name="serieDocumento"
              label="Série"
              variant="filled"
              disabled
              value={orcamento.serieDocumento ?? ""}
              fullWidth
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <DatePicker
            id="dataEmissao"
            name="dataEmissao"
            label="Data de Emissão"
            format="dd/MM/yyyy"
            variant="filled"
            disabled={true}
            value={value.date(orcamento?.dataEmissao)}
          />
        </Grid>
        <Grid item xs={3}>
          <Tooltip
            title="Data de vencimento sugerida de acordo com parâmetro presente em configurações."
            placement="top"
          >
            <DatePicker
              id="dataVencimento"
              name="dataVencimento"
              label="Data de Vencimento"
              format="dd/MM/yyyy"
              disabled
              variant="filled"
              value={value.date(orcamento?.dataVencimento)}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={5}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="operacaoFiscalId"
              name="operacaoFiscalId"
              required
              disabled={id && orcamento.status !== "ABERTO"}
              options={operacaoFiscalList}
              noOptionsText="Sem opções"
              autoHighlight
              getOptionLabel={(option) =>
                option.descricao ? `${option.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Operação Fiscal"
                  variant="outlined"
                  error={inputErros.get("operacaoFiscalId")}
                  required
                />
              )}
              onChange={(e, newValue) => {
                e.persist();
                setInputErro([]);
                handleChangeAutocomplete("operacaoFiscalId", newValue);
                setOrcamento((prevState) => ({
                  ...prevState,
                  operacaoFiscal: newValue,
                  serieDocumento: newValue?.serieDocumento,
                  modeloDocumento: newValue?.modeloDocumento,
                }));
              }}
              value={value.autoComplete(
                operacaoFiscalList,
                orcamento?.operacaoFiscalId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6} className="d-flex align-items-center">
          <Grid
            item
            xs={
              id || !orcamento?.pessoaClienteId || !orcamentos.length ? 28 : 14
            }
          >
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="pessoaClienteId"
                name="pessoaClienteId"
                disabled={id && orcamento.status !== "ABERTO"}
                options={clienteList}
                autoHighlight
                getOptionLabel={(option) => {
                  if (option.nomeRazaoSocial) {
                    if (option.codigo) {
                      return `${option.codigo} - ${option.nomeRazaoSocial}`;
                    }
                    return option.nomeRazaoSocial;
                  }
                }}
                loading={loadingAutoComplete}
                loadingText="Carregando"
                noOptionsText={
                  document.getElementById("pessoaClienteId")?.value.length >=
                    1 && !id ? (
                    <Grid container spacing={1}>
                      <Grid item xs={12} fullWidth>
                        Nenhum cliente encontrado
                      </Grid>
                    </Grid>
                  ) : (
                    "Digite e pressione Enter"
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cliente"
                    variant="outlined"
                    onKeyDown={(e) => onSearchChangePessoas(e, 1)}
                    inputRef={inputCliente}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <React.Fragment>
                            {loadingAutoComplete ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        </>
                      ),
                    }}
                  />
                )}
                onChange={(e, newValue) =>
                  onChangeAutocompleteCliente(newValue)
                }
                value={clienteSelecionado}
              />
            </FormControl>
          </Grid>
          <Grid
            item
            xs={2}
            className="d-flex justify-content-end align-items-center gap-2"
          >
            <Tooltip title="Cadastrar Cliente" arrow placement="bottom">
              <Button
                id="buttonAdicionarCliente"
                variant="contained"
                disabled={id || !orcamento?.operacaoFiscalId}
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => setIsCadastroPessoaDialogOpen(true)}
              >
                <i
                  className="ph-bold ph-plus"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
            {!id && orcamento?.pessoaClienteId && orcamentos?.length ? (
              <>
                {loadingHistorico ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <Tooltip
                    title="Visualizar Histórico Cliente"
                    arrow
                    placement="bottom"
                  >
                    <Button
                      id="buttonHistoricoCliente"
                      variant="contained"
                      disabled={
                        !orcamento?.operacaoFiscalId ||
                        !orcamento?.pessoaClienteId
                      }
                      size="small"
                      sx={{
                        height: "35px",
                        borderRadius: "20%",
                        minWidth: "15px",
                        boxShadow: "none",
                      }}
                      onClick={() => {
                        setOpenHistoricoClienteDialog(true);
                      }}
                    >
                      <i
                        className="ph-fill ph-shopping-cart"
                        style={{ fontSize: 15, color: "white" }}
                      ></i>
                    </Button>
                  </Tooltip>
                )}
              </>
            ) : null}
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="pessoaVendedorId"
              name="pessoaVendedorId"
              disabled={id && orcamento.status !== "ABERTO"}
              options={vendedorList}
              autoHighlight
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vendedor"
                  variant="outlined"
                  error={inputErros.get("pessoaVendedorId")}
                  required
                />
              )}
              onChange={(e, newValue) => {
                e.persist();
                setInputErro([]);
                handleChangeAutocomplete("pessoaVendedorId", newValue);
              }}
              value={value.autoComplete(
                vendedorList,
                orcamento?.pessoaVendedorId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={5.75}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              required
              id="meioPagamentoId"
              name="meiosDePagamento"
              disabled={id && orcamento.status !== "ABERTO"}
              options={meiosPagamentoCliente ?? meioPagamentoList}
              autoHighlight
              getOptionLabel={(option) =>
                option.id && option.descricao
                  ? `${option.id} - ${option.descricao}`
                  : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Meios de pagamento"
                  variant="outlined"
                  error={inputErros.get("meioPagamentoId")}
                  required
                />
              )}
              onChange={(e, newValue) => {
                e.persist();
                handleChangeAutocomplete("meioPagamentoId", newValue);
              }}
              value={value.autoComplete(
                meiosPagamentoCliente ?? meioPagamentoList,
                orcamento?.meioPagamentoId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={5.75}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="condicaoPagamentoId"
              name="condicaoPagamentoId"
              disabled={id && orcamento.status !== "ABERTO"}
              options={condicaoPagamentoList}
              autoHighlight
              getOptionLabel={(option) =>
                option.id && option.descricao
                  ? `${option.id} - ${option.descricao}`
                  : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Condição de Pagamento"
                  variant="outlined"
                  error={inputErros.get("condicaoPagamentoId")}
                  required
                />
              )}
              onChange={(_, newValue) => {
                handleChangeAutocomplete("condicaoPagamentoId", newValue);
              }}
              value={value.autoComplete(
                condicaoPagamentoList,
                orcamento?.condicaoPagamentoId,
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={0.5}>
          <IconButton
            variant="contained"
            size="small"
            className="mt-2"
            onClick={() =>
              setTiposTotalizadoresColumnView(!tiposTotalizadoresColumnView)
            }
          >
            <i
              className="ph-bold ph-caret-down"
              style={{
                color: "#494c62",
                rotate: tiposTotalizadoresColumnView ? "180deg" : "0deg",
              }}
            ></i>
          </IconButton>
        </Grid>
        {tiposTotalizadoresColumnView && (
          <Grid container spacing={2} className="mt-2">
            <Grid item xs={8}></Grid>
            <Grid item xs={2} className="d-flex justify-content-end">
              <FormControlLabel
                label="Desconto por Item"
                labelPlacement="end"
                control={
                  <Checkbox
                    name="descontoItem"
                    checked={orcamento?.descontoItem ?? false}
                    onChange={handleChangeSwitch}
                    color="primary"
                  />
                }
              />
            </Grid>
            <Grid item xs={2} className="d-flex justify-content-end">
              <FormControlLabel
                label="Despesa por Item"
                labelPlacement="end"
                control={
                  <Checkbox
                    name="despesasItem"
                    checked={orcamento?.despesasItem ?? false}
                    onChange={handleChangeSwitch}
                    color="primary"
                  />
                }
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <hr className="mt-4 mb-2" />
      <Paper>
        <Tabs
          value={abaValue}
          onChange={(e, value) => {
            e.persist();
            setAbaValue(value);
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            label="ITENS DA NOTA"
            {...tabProps(0)}
            disabled={
              obrigatoriedadeMeioPagamento && !orcamento?.condicaoPagamentoId
            }
          />
          <Tab label="DADOS DO CLIENTE" {...tabProps(1)} />
          <Tab label="DETALHES" {...tabProps(2)} />
        </Tabs>
      </Paper>
      <CardContent ref={containerRef}>
        <TabPanel value={abaValue} index={0} dir={theme.direction}>
          <OrcamentosItens
            id={id}
            orcamento={orcamento}
            setOrcamento={setOrcamento}
            loadingAutoComplete={loadingAutoComplete}
            timeoutBuscaAutocomplete={timeoutBuscaAutocomplete}
            setLoading={setLoading}
            setLoadingAutoComplete={setLoadingAutoComplete}
            produtoList={produtoList}
            setProdutoList={setProdutoList}
            produto={produto}
            setProduto={setProduto}
            buscarProdutosSimilares={buscarProdutosSimilares}
            produtosSimilares={produtosSimilares}
            setProdutosSimilares={setProdutosSimilares}
            listaOrcamentosProdutos={listaOrcamentosProdutos}
            setListaOcamentosProdutos={setListaOrcamentosProdutos}
            tabelas={tabelas}
            removerProdutoCadastrado={removerProdutoCadastrado}
            origensMercadoriasList={origensMercadoriasList}
            listaUnidadesComerciais={listaUnidadesComerciais}
            setListaUnidadesComerciais={setListaUnidadesComerciais}
            orcamentoEntity={orcamentoEntity}
            acrescimoPagamento={acrescimoPagamento}
            pagamentoSelecionado={pagamentoSelecionado}
            tabelasTodosProdutos={tabelasTodosProdutos}
            enderecosEstoqueList={enderecosEstoqueList}
          />
        </TabPanel>
        <TabPanel value={abaValue} index={1} dir={theme.direction}>
          {abaValue == 1 ? (
            <OrcamentosDadosClientes
              orcamento={orcamento}
              setOrcamento={setOrcamento}
              enderecoAleterado={enderecoAleterado}
              setEnderecoAleterado={setEnderecoAleterado}
              clienteList={clienteList}
              enderecoCliente={enderecoCliente}
              buscarDadosClientes={buscarDadosClientes}
              enderecoClienteDataGrid={enderecoClienteDataGrid}
              clienteSelecionado={clienteSelecionado}
              cidadeId={cidadeId}
              setCidadeId={setCidadeId}
              endereco={endereco}
              setEndereco={setEndereco}
              salvarEndereco={salvarEndereco}
              inputErros={inputErros}
              orcamentoEntity={orcamentoEntity}
            />
          ) : null}
        </TabPanel>
        <TabPanel value={abaValue} index={2} dir={theme.direction}>
          <OrcamentosCampos
            orcamento={orcamento}
            handleChangeInput={handleChangeInput}
          />
        </TabPanel>
        <FullscreenDialog
          open={isCadastroPessoaDialogOpen}
          handleClose={handleCloseCadastroCliente}
          content={
            <AddPessoas
              match={{ params: { id: null } }}
              isFullscreenDialog
              onChangeCliente={onChangeAutocompleteCliente}
              handleCloseFullscreenDialog={handleCloseCadastroCliente}
            />
          }
        />
        <HistorioClienteDialog
          open={openHistoricoClienteDialog}
          setOpen={setOpenHistoricoClienteDialog}
          clienteId={orcamento?.pessoaClienteId}
          orcamentos={orcamentos}
          setOrcamentos={setOrcamentos}
          totalItems={totalItems}
          setTotalItems={setTotalItems}
        />
      </CardContent>
      <ComissaoVendedorDialog
        itemValorComissaoVendedor={itemValorComissaoVendedor}
        setItemValorComissaoVendedor={setItemValorComissaoVendedor}
        itemPercentualComissaoVendedor={itemPercentualComissaoVendedor}
        setItemPercentualComissaoVendedor={setItemPercentualComissaoVendedor}
        itemTotalComissaoVendedor={itemTotalComissaoVendedor}
        setItemTotalComissaoVendedor={setItemTotalComissaoVendedor}
        listaOrcamentosProdutos={listaOrcamentosProdutos}
      />
    </AddLayout>
  );
};

export default AddOrcamentosView;
